import {CompetitorMatchesPageRouteMetaDataModel} from "./competitor.matches-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitorPageRouteConfig} from "../../../models/competitor.page-route.config";
import {CompetitorMatchesPageMatchModel} from "./competitor.matches-page.match-model";

export class CompetitorMatchesPageRouteConfig extends CompetitorPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITOR.matches,
      path: `matches`,
      componentImport: () => import("../components/competitor.matches-page" /* webpackChunkName: "competitor.matches-page" */ ),
      metadataType: CompetitorMatchesPageRouteMetaDataModel,
      matchType: CompetitorMatchesPageMatchModel
    });
  }
}
